import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AccountService } from './services/account.service';
import { AccountDeviceViewModel, AccountError, AccountViewModel, GetRemovalAccount, GetRemovalsAccountResult } from './model/account.model';
import { BoolToAffirmation } from '../../common/custom.datepipe';
import { OrderTrackingService } from '../order-tracking/services/order-tracking.service';
import { OrderTrakingModel } from '../order-tracking/model/order-traking.model';

@Component({
  selector: 'app-account-component',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})

export class AccountComponent implements OnInit {
  currentUser: {};
  txtSearch: string = "";
  accountDeletedSelected: number = null;
  accountBlockedSelected: boolean = null;
  accountSuspectedFraudSelected: boolean = null;
  loading: boolean;

  changeTo: boolean;
  textConfirm: string;
  textError: AccountError[];

  public page: number = 1;
  public pageSize: number = 10;
  public total: number;
  public hasRemovalAccount: number;

  public accounts: AccountViewModel[];
  public removalsAccount: GetRemovalAccount[];
  public removalAccountSelected: GetRemovalAccount;
  public accountSelected: AccountViewModel;
  public deviceSelected: AccountDeviceViewModel;
  public accountOrderSelected: OrderTrakingModel;
  public accountsByDevice: AccountViewModel[];

  constructor(
    private accountService: AccountService,
    private orderTrackingService: OrderTrackingService
  ) {
  }

  ngOnInit() {
    if (!this.loggedUser()) {
      window.location.href = "/authentication";
    }
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.getAccounts();
  }

  public doSearch($event: Event) {
    this.txtSearch = ($event.target as HTMLInputElement).value;
    this.getAccounts();
  }

  public doSearchClear() {
    this.txtSearch = "";
    this.getAccounts();
  }

  public refrehPage() {
    this.getAccounts();
  }

  public getAccounts() {
    this.loading = true;
    this.checkRemovalAccount();

    this.accountService.getAccounts(this.page, this.pageSize, this.txtSearch, this.accountBlockedSelected, this.accountSuspectedFraudSelected, this.accountDeletedSelected)
      .subscribe(result => {
        try {
          this.loading = false;
          this.accounts = result.result;
          this.pageSize = result.paging.pageSize;
          this.page = result.paging.currentPage;
          this.total = result.paging.totalRecords;
        } catch (er) {
          this.loading = false;
          this.accounts = [];
          this.pageSize = result.paging.pageSize;
          this.page = 1;
          this.total = result.paging.totalRecords;
        }
      });
  }

  public checkRemovalAccount() {
    this.accountService.checkRemovalAccount()
      .subscribe(result => {
        try {
          this.hasRemovalAccount = result.result;
        } catch (er) {
          this.hasRemovalAccount = 0;
        }
      });
  }

  public getRemovalAccount(accountId: string) {
    this.loading = true;
    this.accountService.getRemovalAccountResult(accountId)
      .subscribe(result => {
        try {
          this.loading = false;
          this.removalsAccount = result.result;
        } catch (er) {
          this.removalsAccount = [];
          this.loading = false;
        }
      });
  }

  public openmodalDetail(modelName, $event, account: AccountViewModel) {
    this.accountSelected = account;
    this.openModal(modelName, $event);

    this.accountOrderSelected = null;

    this.orderTrackingService.getOrdersByAccountIdService(account.id)
      .subscribe(result => {
        try {
          this.accountOrderSelected = result;
        } catch (er) {
          this.accountOrderSelected = null;
        }
      });
    this.getRemovalAccount(account.id);
  }

  public accountInDevice(modelName, $event, accountsByDevice: AccountViewModel[]) {
    this.accountsByDevice = accountsByDevice;
    this.openModal(modelName, $event)
  }

  public accountChangeResolution(modelName, $event, accountsRemoval: GetRemovalAccount) {
    this.removalAccountSelected = accountsRemoval;
    this.openModal(modelName, $event)
  }

  public sendAnalisyRemovalAccount(modelName, $event) {
    this.loading = true;
    this.accountService.updateStatus(this.removalAccountSelected)
      .subscribe(result => {
        try {
          this.loading = false;
          this.closeModal(modelName);
          this.closeModal('modalDetail');
          this.getAccounts();
        } catch (er) {
          this.loading = false;
        }
      });
  }

  public blockAccount(modelName, $event, device: AccountDeviceViewModel, changeTo: boolean) {
    this.deviceSelected = device;
    this.changeTo = changeTo;
    if (this.accountSelected != null && this.deviceSelected == null) {
      this.textConfirm = changeTo ? "Você confirma o bloqueio desta conta?" : "Você confirma o desbloqueio desta conta?";
    } else if (this.deviceSelected != null) {
      this.textConfirm = changeTo ? "Você confirma o bloqueio deste aparelho?" : "Você confirma o desbloqueio deste aparelho?";
    }
    this.openModal(modelName, $event)
  }

  public setAccountResultFraudAnalysis() {
    this.closeModal("modalAlert");
    this.loading = true;

    if (this.accountSelected != null && this.deviceSelected == null) {
      this.accountService.putAccountBlocked(this.accountSelected.id, this.changeTo)
        .subscribe(result => {
          if (result.success) {
            this.closeModal("modalDetail");
            this.accountSelected = null;
            this.changeTo = null;
            this.refrehPage();
          } else {
            this.textError = result.errors;
            this.loading = false;
            this.openModal("modalError", null);
          }
        }, result => {
          this.accountSelected = null;
          this.changeTo = null;
        });
    } else
      if (this.deviceSelected != null) {
        this.accountService.putDeviceBlocked(this.accountSelected.id, this.deviceSelected.id, this.changeTo)
        .subscribe(result => {
          if (result.success) {
            this.closeModal("modalDetail");
            this.accountSelected = null;
            this.deviceSelected = null;
            this.changeTo = null;
            this.refrehPage();
          } else {
            this.textError = result.errors;
            this.loading = false;
            this.openModal("modalError", null);
          }
        }, result => {
          this.accountSelected = null;
          this.changeTo = null;
        });
    }
  }

  public openModal(modelName, $event) {
    try {
      document.getElementById(modelName).style.display = "block";
      document.getElementById(modelName).style.backgroundColor = "rgba(12, 0, 0, 0.5)";
    } catch (e) {
      let that = this;
      setTimeout(function () { that.openModal(modelName, $event); }, 500);
    }
  }

  public closeModal(modelName) {
    document.getElementById(modelName).style.display = "none";
  }

  public pageChanged(page) {
    this.page = page;
    this.getAccounts();
  }

  public changeAccountBlocked(value) {
    this.accountBlockedSelected = value;
    this.getAccounts();
  }

  public changeAccountDeleted(value) {
    this.accountDeletedSelected = value;
    this.getAccounts();
  }

  public changeAccountSuspectedFraud(value) {
    this.accountSuspectedFraudSelected = value;
    this.getAccounts();
  }

  loggedUser() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      return true;
    }
  }

}

